import { CONTENT_SECTIONS } from '../../../content/sections';
import { ProductType } from '../../../../../types/product';
import constants from '../../../../../ahm-constants';
import ProductService from '../../../../../models/product';

const getHospitalProductListingContent = (products: Record<string, ProductType>) => {
  const recommendedProductIds = [
    constants.PRODUCT.AMBULANCE_AND_ACCIDENT_BASIC_EXCESS_750,
    constants.PRODUCT.CORE_HOSPITAL_BASIC_PLUS_EXCESS_750,
    constants.PRODUCT.STARTER_BRONZE_EXCESS_750,
  ];

  const recommendedProducts = ProductService.getProducts(products, recommendedProductIds);

  return {
    compareButtonText: 'See more hospital products',
    compareButtonToLink: constants.URLS.SALES.PRODUCT_LISTING_HOSPITAL,
    data: {
      title: 'Find hospital cover that suits your needs',
    },
    orderIndex: 3,
    products: recommendedProducts,
    type: CONTENT_SECTIONS.PRODUCT_LISTING,
    withBorder: true,
  };
};

export default getHospitalProductListingContent;
